@if (session) {
  <card-container
    #cardContainer
    (contextmenu)="openMenu($event)"
    [attr.aria-label]="cardAriaLabel()"
    class="card-container {{FirstCommentTourClasses.sessionCard}}"
    [ngClass]="{ 'viewed': !unviewedState(session) }"
    (click)="onCardClick($event)"
    (keyup.enter)="onCardKeyEnter($event)"
    data-cy="session-row-or-card"
    [matTooltip]="getTooltip(session)"
    [matTooltipDisabled]="!sessionDescriptionTruncated"
    matTooltipClass="formatTooltip"
    role="link"
    tabindex="0">
    <div main class="main">
      @if (isSubmitCheckboxActive()) {
        <mat-checkbox
          data-tour="submit-selection-checkbox"
          class="submit-selection-checkbox"
          color="primary"
          data-cy="submit-checkbox"
          [checked]="isSelected"
          [disabled]="isSubmittingSessions"
          [tabindex]="(!allowSelection || isSubmittingSessions) ? -1 : 0"
          [aria-label]="'activity-task-sessions_submit-checkbox-aria-label' | translate"
          (click)="$event.stopPropagation()"
          (change)="handleCheckboxChanges($event)">
        </mat-checkbox>
      }
      @if (isSubmitOverlayActive()) {
        <div
          class="submit-overlay"
          aria-hidden="true"
          (click)="onSelectionToggle($event)">
        </div>
      }
      @if (shouldShowSubmissionBadge()) {
        <badge
          class="submit-video-complete-badge"
          [badgeColor]="BadgeColors.SUCCESS"
          [badgeLabel]="'common_submitted' | translate">
        </badge>
      }
      <!-- #region Recorded Thumbnail -->
      @if (session.isRecorded()) {
        @if(!submitMode) {
          <dot-indicator
            [session]="session"
            [size]="12"
            [hasBorder]="true">
          </dot-indicator>
        }
        @if (!ngxSessionService.getMedia(session)) {
          <div class="pending-thumbnail">
            @if (selectedService.getActivity().isConversationBoard()) {
              <span>
                <img class="logo not-loading"
                  [alt]="spotLogo.alt"
                  [src]="spotLogo.src"/>
              </span>
            } @else {
              <loading [width]="'70px'" [height]="'70px'"></loading>
            }
          </div>
        } @else {
          @if (ngxSessionService.getMedia(session).isReady()) {
            <thumbnail
              data-cy="media-ready"
              [src]="ngxSessionService.getMedia(session).thumbnail_url"
              [duration]="ngxSessionService.getMedia(session).duration"
              [fallbackIcon]="'ficon-app-camcorder'"
              class="recorded-thumbnail"
              >
            </thumbnail>
          }
          @if (ngxSessionService.getMedia(session).isPending()) {
            <div class="pending-thumbnail">
              <loading [width]="'70px'" [height]="'70px'"></loading>
            </div>
          }
          @if (ngxSessionService.getMedia(session).isFailed()) {
            <div class="failed-thumbnail">
              <i class="ficon-app-warning-circle-outline"></i>
            </div>
          }
        }
      }
      <!-- endregion -->
      <!-- #region Live Thumnbnail -->
      @if (!session.isRecorded()) {
        <dot-indicator
          [session]="session"
          [size]="12"
          [color]="(session.isLive() && selectedService.getActivity().isLiveSessionEnabled()) ? 'red' : 'green'"
          [hasBorder]="!(session.isLive() && selectedService.getActivity().isLiveSessionEnabled())">
        </dot-indicator>
        <div class="live-thumbnail">
          @if (ngxSessionService.shouldDisplayJoinButton(session)) {
            <button  class="join-btn secondary-btn">{{'session-join' | translate}}</button>
          }
        </div>
      }
      <!-- endregion -->
    </div>
    <div
      info-first-line
      data-cy="session-description"
      detectTextTruncation
      (truncatedChange)="handleTruncatedChange($event)"
      >
      {{ session.description }}
      @if (!session.description?.length) {
        <span>&#8212;</span>
      }
    </div>
    <div info-second-line>
      <ellipsis-with-count [nameList]="nameList"></ellipsis-with-count>
      @if (!nameList.length) {
        @if (selectedService.getActivity().isConversationBoard()) {
          <span class="group-discussion" translate="filter-presenter-names_group"></span>
        } @else {
          <span>&#8212;</span>
        }
      }
    </div>
    <div info-third-line>
      <!-- #region Recorded information -->
      @if (session.isRecorded()) {
        <div>
          @if (!ngxSessionService.getMedia(session)) {
            <span class="pending-text">
              @if (selectedService.getActivity().isConversationBoard()) {
                <span>—</span>
              } @else {
                <span translate="single-attempt-activity_no-recording" data-cy="allow-retake-link"></span>
              }
            </span>
          } @else {
            @if (ngxSessionService.getMedia(session).isReady()) {
              @if (session.isPosted() && shouldDisplaySubmissionDate(session)) {
                <span class="date-posted-container">
                  <div>
                    <span class="date-posted-label">
                      {{ 'session-card_date-submission-label' | translate }}
                    </span>
                    <span [ngClass]="{'red': isSubmittedLate(session)}" class="date-posted">
                      @if (isSubmittedLate(session)) {
                        <span class="ficon-app-warning-circle-outline warning-icon red"
                          [matTooltip]="'session-list_submission_late' | translate"
                          matTooltipPosition="above"
                          tabindex="0">
                        </span>
                      }
                      {{ session.posted_at | date: 'MMM d, y' }}
                    </span>
                  </div>
                  @if (ngxSessionService.shouldDisplayScore(session)) {
                    @if (session.isScoreAssigned()) {
                      <span class="score">
                        {{session.score}}/{{selectedService.getActivity().getTotalPoints()}}
                      </span>
                    } @else {
                      <span class="unscored" translate="common_unscored"></span>
                    }
                  }
                </span>
              } @else {
                <span class="session-created-text" translate="session-date-created-label"></span>
                <span class="session-created-date">
                  {{ session.created_at | date: 'MMM d, y' }}
                </span>
              }
            }
            @if (ngxSessionService.getMedia(session).isPending()) {
              <span class="pending-text" translate="common_processing_processing" data-cy="processing-text"></span>
            }
            @if (ngxSessionService.getMedia(session).isFailed()) {
              <span class="failed-text red-text" translate="common_processing_failed"></span>
            }
          }
        </div>
      }
      <!-- endregion -->
      <!-- #region Live information -->
      @if (!session.isRecorded()) {
        <div>
          @if (session.isAwaitingStart()) {
            <span class="awaiting-text" translate="common_processing_awaiting-start"></span>
          }
          @if (session.isLive() && selectedService.getActivity().isLiveSessionEnabled()) {
            <span class="is-live-text red-text" translate="common_processing_in-progress"></span>
          }
        </div>
      }
      <!-- endregion -->
    </div>
    <div info-third-line-action-btns (keyup.enter)="$event.stopPropagation();">
      <!-- #region Comment Button -->
      @if (session.num_comments > 0) {
        <span
          class="comment-btn"
          role="button"
          [attr.aria-label]="session.num_comments + ' ' + (session.num_comments === 1 ? ('common_comment' | translate) : ('common_comments' | translate))"
          >
          <i class="ficon-app-comment-outline"></i>
          <span class="num-comments">
            {{session.num_comments}}
          </span>
        </span>
      }
      <!-- endregion -->
      <!-- #region Menu Button -->
      @if (ngxSessionService.shouldDisplayOptionsMenu(session)) {
        <button
          class="menu-btn btn-none"
          data-cy="session-dropdown-menu"
          (click)="openMenu($event)"
          [attr.aria-label]="'session-list-item_view-options' | translate"
          [attr.aria-expanded]="menuComponent?.contextMenu?.menuOpen ? 'true' : 'false'"
          (keyup.enter)="$event.stopPropagation();">
          <i class="ficon-app-dots-vertical"></i>
        </button>
      }
      <!-- endregion -->
      <!-- #region Menu -->
      <menu>
        <session-menu [session]="session"></session-menu>
      </menu>
      <!-- endregion -->
    </div>
  </card-container>
}
